'use strict';

var toastMessageHelper = require('./utils/toastMessageHelper');
var addressUtils = require('./utils/addressUtils');
var loadExternalStyle = require('./utils/loadExternalStyle');

var checkoutBeginUrl = $('#checkout-begin-url').val();
var guestLoginModalStylesPromise;

// Debounce timer to avoid too many API calls
var pincodeTimer = null;

/**
 * appends params to a url
 * @param {string} uri - Original url
 * @param {string} key - Parameters to append
 * @param {string} value - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(uri, key, value) {
    // Create a regex pattern to find the key in the URI
    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    var separator = uri.indexOf('?') !== -1 ? '&' : '?';
    // If the key exists, replace its value; otherwise, append the key-value pair
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2');
    }
    return uri + separator + key + '=' + value;
}

/**
 * Initiates the "Buy Now" process by simulating a click on the 'Buy Now' button if the current page is a product page.
 *
 * @returns {void}
 */
function continuebuynow() {
    const pageDOM = $('.page');
    if ((pageDOM && pageDOM.length && pageDOM.data('action') === 'Product-Show') || (pageDOM && pageDOM.length && pageDOM.data('action') === 'Search-Show') || (pageDOM && pageDOM.length && pageDOM.data('action') === 'Cart-Show')) {
        // Get the specific product ID that was stored when buy now was clicked
        const targetProductId = sessionStorage.getItem('buyNowProductId');
        let buynowBtn;
        if (targetProductId) {
            // Try multiple selectors to find the specific product's add-to-cart button
            buynowBtn = $('button.add-to-cart.buy-now[data-pid="' + targetProductId + '"]');
        }
        // Fallback to first button if specific product not found (for PDP)
        if (!buynowBtn || !buynowBtn.length) {
            buynowBtn = $('button.add-to-cart').first();
        }
        if (buynowBtn && buynowBtn.length) {
            $(buynowBtn).addClass('proceed-checkout').data('authcustomer', true);
            $('body').trigger('product:beforeAddToCart', buynowBtn[0]);
            $(buynowBtn).trigger('click');
            sessionStorage.removeItem('buyNowProductId');
        }
    } else if (pageDOM && pageDOM.length && pageDOM.data('action') === 'Product-ShowDiamond') {
        var targetProductId = sessionStorage.getItem('buyNowProductId');
        var buynowBtn;

        if (targetProductId) {
            buynowBtn = $('.diamond-on-call-action-btns button.add-diamond-buy-now');
        }

        if (buynowBtn && buynowBtn.length) {
            $(buynowBtn).addClass('proceed-checkout').data('authcustomer', true);
            $('body').trigger('product:beforeAddToCart', buynowBtn[0]);
            $(buynowBtn).prop('disabled', false);
            $(buynowBtn).trigger('click');
            sessionStorage.removeItem('buyNowProductId');
        }
    }
}

/**
 * Handles country change for guest checkout (shipping/billing) and updates form fields dynamically.
 *
 * @function handleGuestCountryChange
 * @param {jQuery} $el - The selected country element containing data attributes.
 *
 * @description
 * - Detects whether the change is in shipping or billing form.
 * - Updates selected country code and country name.
 * - Updates phone input attributes (maxlength, pattern, dialing code).
 * - Clears address-related fields (pincode, city, state, address, phone).
 * - Shows or hides state and postal code fields based on country configuration.
 * - Applies or removes required validation for state and postal fields.
 * - Prevents execution if the selected country is the same as the previous one.
 *
 * @returns {void}
 */
function handleGuestCountryChange($el) {
    var selectedCountry = $el.data('id');

    // Find whether this is shipping or billing section
    var formContainer = $el.closest('.guest-checkout-address-form-container');

    var pincodeInput = formContainer.find('input[id$="Pincode"]');
    var cityInput = formContainer.find('input[id$="City"]');
    var stateInput = formContainer.find('input[id$="State"]');
    var addressInput = formContainer.find('input.address-section');
    var phoneInput = formContainer.find('.phone-input-wrapper .phone-input');
    var mobileDialingCode = formContainer.find('.mobile-dialing-code');
    var prevCountryCode = formContainer.find('.country-code');
    var countryName = $el.data('countryname');

    // Update phone input attributes
    var phoneMaxLength = $el.data('phonelength');
    var phoneRegExp = $el.data('regexp');
    var dialCode = $el.data('countrycode');

    var hasStates = $el.attr('data-hasstates') === 'true';
    var hasPostal = $el.attr('data-haspostal') === 'true';

    if (selectedCountry === prevCountryCode.val()) {
        return;
    }

    prevCountryCode.val(selectedCountry);
    prevCountryCode.attr('data-countryname', countryName);

    phoneInput
        .attr('maxlength', phoneMaxLength)
        .attr('data-phonelength', phoneMaxLength)
        .attr('pattern', phoneRegExp)
        .attr('data-countrycode', dialCode)
        .val('');

    mobileDialingCode.val(dialCode);

    pincodeInput.val('');
    cityInput.val('');
    stateInput.val('');
    addressInput.val('');

    var stateGroup = stateInput.closest('.form-group');
    var stateGroupWrapper = stateInput.closest('.form-group-wrapper');

    if (!hasStates) {
        stateGroup.removeClass('required');
        stateGroupWrapper.addClass('d-none');
        stateInput.val('');
    } else {
        stateGroup.addClass('required');
        stateGroupWrapper.removeClass('d-none');
    }

    var postalGroup = pincodeInput.closest('.form-group');
    var postalGroupWrapper = pincodeInput.closest('.form-group-wrapper');

    if (!hasPostal) {
        postalGroup.removeClass('required');
        postalGroupWrapper.addClass('d-none');
    } else {
        postalGroup.addClass('required');
        postalGroupWrapper.removeClass('d-none');
    }
}

/**
 * Handles profile country change and resets related fields.
 * @param {jQuery} $el - Selected country element with data-id and data-name
 */
function ckcProfileCountryChange($el) {
    const countryValue = $el.data('id');
    var prefix = 'profile';
    // Update hidden input
    $('#profileCountry').val(countryValue);
    $('#profileCountry').attr('data-value', $el.data('name'));
    $('#profilePincode').val('');
    $(`#${prefix}City`).val('');
    $(`#${prefix}State`).val('');
    if ($el.data('state')) {
        $('#profileState').closest('.form-group').removeClass('d-none').addClass('required');
    } else {
        $('#profileState').closest('.form-group').addClass('d-none').removeClass('required');
    }
    if ($el.data('postal')) {
        $('#profilePincode').closest('.form-group').removeClass('d-none').addClass('required');
    } else {
        $('#profilePincode').closest('.form-group').addClass('d-none').removeClass('required');
    }

    $('#profile-address1, #profile-address2').val('');
}

/**
 * Handles ERP profile country change and resets related fields.
 * @param {jQuery} $el - Selected country element with data-country-id and data-name
 */
function erpProfileCountryChange($el) {
    const countryValue = $el.data('country-id');
    var prefix = 'erpProfile';

    // Update hidden input
    $('#erpProfileCountry').val(countryValue);
    $('#erpProfileCountry').attr('data-value', $el.data('country-name'));
    $('#erpProfilePincode').val('');
    $(`#${prefix}City`).val('');
    $(`#${prefix}State`).val('');
    if ($el.data('state')) {
        $('#erpProfileState').closest('.form-group').removeClass('d-none').addClass('required');
    } else {
        $('#erpProfileState').closest('.form-group').addClass('d-none').removeClass('required');
    }
    if ($el.data('postal')) {
        $('#erpProfilePincode').closest('.form-group').removeClass('d-none').addClass('required');
    } else {
        $('#erpProfilePincode').closest('.form-group').addClass('d-none').removeClass('required');
    }
    $('#erp-profile-address1, #erp-profile-address2').val('');
}

/**
 * Ensures the shared login modal stylesheet is available before the guest modal opens.
 *
 * @returns {Promise<JQuery>} Resolves with the guest login modal element.
 */
function ensureGuestLoginModalStylesLoaded() {
    var $guestLoginModal = $('#ckc-guest-login-modal');
    var loginModalStyleUrl = $guestLoginModal.data('loginModalStyleUrl');

    if (!$guestLoginModal.length) {
        return Promise.resolve($guestLoginModal);
    }

    if ($guestLoginModal.attr('data-styles-loaded') === 'true' || !loginModalStyleUrl) {
        $guestLoginModal.attr('data-styles-loaded', 'true');
        return Promise.resolve($guestLoginModal);
    }

    if (guestLoginModalStylesPromise) {
        return guestLoginModalStylesPromise;
    }

    guestLoginModalStylesPromise = loadExternalStyle(loginModalStyleUrl)
        .then(function () {
            $guestLoginModal.attr('data-styles-loaded', 'true');
            return $guestLoginModal;
        }).catch(function (error) {
            guestLoginModalStylesPromise = null;
            throw error;
        });

    return guestLoginModalStylesPromise;
}

$('#ckc-guest-login-modal').on('show.bs.modal', function (event) {
    var $guestLoginModal = $(this);

    if ($guestLoginModal.attr('data-styles-loaded') === 'true') {
        return;
    }

    event.preventDefault();

    ensureGuestLoginModalStylesLoaded().then(function () {
        $guestLoginModal.modal('show');
    }).catch(function () {
        // Leave the modal closed when the stylesheet cannot be loaded.
    });
});

$('body').on('click', '.guest-login-continue-button .guest-continue-button', function (e) {
    e.preventDefault();

    var $guestLoginModal = $('#ckc-guest-login-modal');
    var $loginOrGuestContainer = $guestLoginModal.find('.login-or-guest-container');
    var $guestAddressContainer = $guestLoginModal.find('.guest-checkout-address-container');

    var url = $(this).data('guest-address-url');
    $.spinner().start();

    // Make AJAX call to get guest address form
    $.ajax({
        url: url,
        type: 'GET',
        dataType: 'html',
        success: function (response) {
            // Hide login/guest container
            $loginOrGuestContainer.addClass('d-none');

            // Populate and show guest address container
            $guestAddressContainer.html(response);
            $guestAddressContainer.removeClass('d-none');
            $guestAddressContainer.scrollTop(0);
            if (!$('.proceed-to-checkout').val()) {
                const appendedUrl = appendToUrl(window.location.href, 'buynow', true);
                window.history.pushState({ segmentVal: '#buynow' }, '', appendedUrl);
            } else {
                $('.checout-guest-login').val(true);
            }
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
});

$('body').on('click', '#ckc-guest-login-modal .guest-cta-section .back-cta', function (e) {
    e.preventDefault();

    var $guestLoginModal = $('#ckc-guest-login-modal');
    var $loginOrGuestContainer = $guestLoginModal.find('.login-or-guest-container');
    var $guestAddressContainer = $guestLoginModal.find('.guest-checkout-address-container');
    var $guestInput = $('#guestLoginInput');

    // Show login/guest container
    $loginOrGuestContainer.removeClass('d-none');
    $guestInput.val('');

    if ($guestInput.attr('name') === 'phone') {
        $guestInput.attr('name', 'email');
        $('.guest-country-select-wrap').addClass('d-none');
        $guestInput.addClass('w-100').removeClass('w-75');
        $('.guest-password-validation-link').removeClass('d-none');
        $guestInput.removeClass('country-code-field');
    }
    $('.guest-password-validation-link').addClass('d-none');
    $('.login-modal-missing-error, .login-modal-result, .login-mobile-country-miss-match-error').addClass('d-none');

    // Hide guest address container
    $guestAddressContainer.addClass('d-none');
    $guestAddressContainer.html('');
});

$('body').on('change', '#billing-same-as-shipping', function () {
    var $billingFormContainer = $('#billing-address-form-container');

    if ($(this).is(':checked')) {
        // Checkbox is checked - hide billing form
        $billingFormContainer.addClass('d-none');
    } else {
        // Checkbox is unchecked - show billing form
        $billingFormContainer.removeClass('d-none');
    }
});

$('#ckc-guest-login-modal').on('hidden.bs.modal', function () {
    var $loginOrGuestContainer = $(this).find('.login-or-guest-container');
    var $guestAddressContainer = $(this).find('.guest-checkout-address-container');
    const url = new URL(window.location);
    url.searchParams.delete('buynow'); // remove query param
    window.history.replaceState({}, '', url.pathname + url.search);

    // Show login/guest container
    $loginOrGuestContainer.removeClass('d-none');

    // Hide guest address container and clear its content
    $guestAddressContainer.addClass('d-none');
    $guestAddressContainer.html('');
});

// Validate on input change
$('body').on('input change blur', '#guest-shipping-form input, #guest-shipping-form select', function () {
    addressUtils.validateField($(this));
});

$('body').on('input change blur', '#guest-billing-form input, #guest-billing-form select', function () {
    addressUtils.validateField($(this));
});

$('body').on('submit', '#guest-address-form', function (e) {
    e.preventDefault();

    var allValid = true;
    var isBillingSame = $('#billing-same-as-shipping').is(':checked');

    $('#guest-shipping-form').find('input').each(function () {
        if (!addressUtils.validateField($(this))) {
            allValid = false;
        }
    });

    if (isBillingSame) {
        if (allValid) {
            // Copy all shipping field values to billing form
            $('#guest-shipping-form').find('input').each(function () {
                var fieldId = $(this).attr('id'); // e.g., guestShippingFirstName
                var shippingValue = $(this).val();

                // Replace "guestShipping" with "guestBilling"
                var billingFieldId = fieldId.replace('guestShipping', 'guestBilling');

                var $billingField = $('#' + billingFieldId);

                if ($billingField.length) {
                    if (fieldId === 'guestShippingPincode') {
                        $('#guestBillingPincode').val(shippingValue); // copy exact value
                    } else {
                        $billingField.val(shippingValue).trigger('input');
                    }
                }
            });
        }
    } else {
        $('#guest-billing-form').find('input').each(function () {
            if (!addressUtils.validateField($(this))) {
                allValid = false;
            }
        });
    }

    if (allValid) {
        var currentUrlParams = new URLSearchParams(window.location.search);
        var buyNowFlow = currentUrlParams.get('buynow') || false;
        var formData = $(this).serialize();

        var url = $(this).data('action-url');
        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: formData + '&buynow=' + buyNowFlow,
            success: function (response) {
                if (response.success) {
                    let loginUrl = new URL(window.location.href);
                    loginUrl.searchParams.set('ckcLogin', true);
                    var activeTab = window.history.state ? window.history.state : undefined;
                    if (buyNowFlow && activeTab && activeTab.segmentVal === '#buynow') {
                        continuebuynow();
                    } else {
                        window.location.href = checkoutBeginUrl;
                    }
                } else {
                    toastMessageHelper.showNotification(response.message || $('#errorSavingAddress').val());
                }
                $('#ckc-guest-login-modal').modal('hide');
                $.spinner().stop();
            },
            error: function () {
                toastMessageHelper.showNotification(response.message || $('#errorSavingAddress').val());
                $.spinner().stop();
            }
        });
    }
});

$('.ckc-country-drop-down-section .guest-dropdown').on('click', function () {
    $(this).siblings('.custom-option-values').toggle();
});

$('body').on('click', '#guest-shipping-form .ckc-country-drop-down-section .country-value, #guest-billing-form .ckc-country-drop-down-section .country-value', function () {
    handleGuestCountryChange($(this));
});

$('body').on('input', '#guestShippingPincode, #guestBillingPincode', function () {
    var pincode = $(this).val().trim();

    // Read extra attributes
    var group = $(this).data('group');
    var prefix = $(this).data('prefix');

    // Build dynamic ID path
    var idPrefix = `${group}${prefix.charAt(0).toUpperCase() + prefix.slice(1)}`;

    var country = $(`#${idPrefix}Country`).attr('data-countryname');

    if (pincode.length < 4) {
        $(`#${idPrefix}City`).val('');
        $(`#${idPrefix}State`).val('');
        return;
    }

    clearTimeout(pincodeTimer);
    pincodeTimer = setTimeout(function () {
        addressUtils.fetchPlace(idPrefix, pincode, country);
    }, 400);
});

$('body').on('click', '#guest-shipping-form .title-code-option, #guest-billing-form .title-code-option', function () {
    var selectedTitleCode = $(this).data('code');

    // Find whether this is shipping or billing section
    var formContainer = $(this).closest('.guest-checkout-address-form-container');
    var titleCodeInput = formContainer.find('.title-code');

    titleCodeInput.val(selectedTitleCode);
});

$(document).on('click', '.ckc-profile-country-drop-down-section .custom-option-value', function () {
    ckcProfileCountryChange($(this));
});

$(document).on('click', '.erp-profile-country-drop-down-section .custom-option-value', function () {
    erpProfileCountryChange($(this));
});

$('body').on('input', '#profilePincode', function () {
    var pincode = $(this).val().trim();
    var prefix = 'profile';
    var country = $(`#${prefix}Country`).attr('data-value').trim();

    if (pincode.length < 4) {
        $(`#${prefix}City`).val('');
        $(`#${prefix}State`).val('');
        return;
    }

    // Debounce: wait 400ms after user stops typing
    clearTimeout(pincodeTimer);
    pincodeTimer = setTimeout(function () {
        addressUtils.fetchPlace(prefix, pincode, country);
    }, 400);
});

$('body').on('input', '#erpProfilePincode', function () {
    var $input = $(this);
    var pincode = $.trim($input.val());

    // Extract prefix dynamically
    var prefix = 'erpProfile';
    var country = $(`#${prefix}Country`).attr('data-value').trim();

    // Clear city & state if pincode too short
    if (pincode.length < 4) {
        $(`#${prefix}City`).val('');
        $(`#${prefix}State`).val('');
        return;
    }

    // Debounce API call
    clearTimeout(pincodeTimer);
    pincodeTimer = setTimeout(function () {
        addressUtils.fetchPlace(prefix, pincode, country);
    }, 400);
});

window.handleGuestCountryChange = handleGuestCountryChange;
window.ckcProfileCountryChange = ckcProfileCountryChange;
window.erpProfileCountryChange = erpProfileCountryChange;
